import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  METHOD_FEATURE_KEY,
  MethodState,
  methodAdapter,
} from './method.reducer';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';
import { selectAllBooks, selectBookEntities } from '../book/book.selectors';
import { selectBookSelectPersonUsesBook } from '../person-uses-book/person-uses-book.selectors';
import { selectBookSelectModalScopeId } from '../scope/scope.selectors';

export const selectMethodState =
  createFeatureSelector<MethodState>(METHOD_FEATURE_KEY);

const { selectAll } = methodAdapter.getSelectors();

export const selectAllMethods = createSelector(
  selectMethodState,
  (state: MethodState) => selectAll(state),
);

export const selectScopeMethodsCallState = createSelector(
  selectMethodState,
  (state: MethodState) => state.scopeMethodsCallState,
);

export const selectScopeMethodsLoading = createSelector(
  selectScopeMethodsCallState,
  (callState: CallState) =>
    callState === LoadingState.INIT || callState === LoadingState.LOADING,
);

export const selectScopeMethodsLoaded = createSelector(
  selectScopeMethodsCallState,
  (callState: CallState) => callState === LoadingState.LOADED,
);

export const selectScopeMethodsError = createSelector(
  selectScopeMethodsCallState,
  (callState: CallState) => getError(callState),
);

export const selectBookSelectMethods = createSelector(
  selectAllMethods,
  selectBookSelectModalScopeId,
  (methods, scopeId) =>
    scopeId
      ? methods.filter((method) => method.scopeIds.includes(scopeId))
      : [],
);

export const selectBookSelectMethodIds = createSelector(
  selectBookSelectMethods,
  (methods) => methods.map((method) => method.id),
);

export const selectBookSelectModalBooks = createSelector(
  selectAllBooks,
  selectBookSelectMethodIds,
  selectBookSelectModalScopeId,
  (books, methodIds, scopeId) =>
    scopeId
      ? books.filter((book) =>
          book.scopeIds
            ? methodIds.includes(book.methodId) &&
              book.scopeIds.includes(scopeId)
            : false,
        )
      : [],
);

export const selectBookSelectCurrentBook = createSelector(
  selectBookEntities,
  selectBookSelectPersonUsesBook,
  (books, personUsesBook) =>
    personUsesBook ? books[personUsesBook.bookId] : undefined,
);
